import { TLang } from '@/utils/lang';
import React, { useState, useEffect, useRef } from 'react';
import { gioClick } from '@/utils/gioApi';
import DFImage from '../dFImage';
import { setDataGioList, checkExposureGio, clearGioStatus } from './gioUtils';
import styles from './index.less';
import RightIcon from '@/assets/imgs/right-icon.png';

const ViewMoiveFood = (props: any) => {
  const sliderRef = useRef(null);
  const { onlineOrderList } = props;
  const [firstLoad, setFirstLoad] = useState<boolean>(true);

  /*** 曝光的代码 */
  const dataList = useRef(onlineOrderList);

  useEffect(() => {
    if (firstLoad) {
      clearGioStatus();
      setDataGioList(onlineOrderList);
      dataList.current = onlineOrderList;
      const $dom = document.getElementById('viewMovieFood');
      if (onlineOrderList?.length > 0 && $dom) {
        checkExposureGio(dataList.current);
        setFirstLoad(false);
      }
    }
  }, [onlineOrderList]);

  const gioExposure = () => {
   checkExposureGio(dataList.current);
  };

  useEffect(() => {
    const element = document.getElementById('pullToRefresh');
    element?.addEventListener('scroll', gioExposure);
    return () => {
      element?.removeEventListener('scroll', gioExposure);
    };
  }, [onlineOrderList]);

  useEffect(() => {
    const handleTouchStart = (event) => {
      const touch = event.touches[0];
      const startX = touch.pageX;
      sliderRef?.current?.addEventListener('touchmove', (event) => {
        gioExposure();
      });
    };
    sliderRef?.current?.addEventListener('touchstart', handleTouchStart);
    return () => {
      sliderRef?.current?.removeEventListener('touchstart', handleTouchStart);
    };
  }, [onlineOrderList]);
  /*** 曝光的代码 */

  const goLink = (item, index, link) => {
    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '观影美食', elementname: '观影美食', floorNum: 4, HPbanenrNum: index+1, JumpAddress: link, contentTitle: item.name});
    setTimeout(() => {
      window.df_sdk_common.location.href = link;
    }, 50);
  };

  const renderList = () => {
     // 展示一排大于5个的情况
    if (props.onlineOrderList.length > 5) {
      return (
        <ul className={styles.list}>
          {props.onlineOrderList.map((item, idx) => (
            <li key={idx} id={`delicacy${idx}`} className={styles.item}  onClick={() => {
              // window.df_sdk_common.location.href = item?.linkUrl;
              goLink(item, idx, item.linkUrl);
            }}
            >
              <div className={`${styles.img}`}>
                <DFImage src={item?.logo} key={item.id}></DFImage>
                <div className={styles.text}>{item?.name}</div>
              </div>
            </li>
          ))}
        </ul>
      );
    }

    // 展示一排3-5个的情况
    if (props.onlineOrderList.length <= 5 && props.onlineOrderList.length >= 3) {
      return (
        <ul className={`${styles.list} ${styles.list_center}`}>
          {props.onlineOrderList.map((item, idx) => (
            <li key={idx} id={`delicacy${idx}`} className={styles.item}  onClick={() => {
              // window.df_sdk_common.location.href = item?.linkUrl;
              goLink(item, idx, item.linkUrl);
            }}
            >
              <div className={`${styles.img}`}>
                <DFImage src={item?.logo} key={item.id}></DFImage>
                <div className={styles.text}>{item?.name}</div>
              </div>
            </li>
          ))}
        </ul>
      );
    }

    // 展示一排二个的情况
    if (props.onlineOrderList.length == 2) {
      return (
        <ul className={`${styles.list} ${styles.list_two}`}>
          {props.onlineOrderList.map((item, idx) => (
            <li key={idx} id={`delicacy${idx}`} className={styles.item} onClick={() => {
              // window.df_sdk_common.location.href = item?.linkUrl;
              goLink(item, idx, item.linkUrl);
            }}
            >
              <div className={`${styles.img}`}>
                <DFImage src={item?.logo} key={item.id}></DFImage>
                <div className={styles.text}>{item?.name}</div>
              </div>
            </li>
          ))}
        </ul>
      );
    }
    // 展示一排一个的情况
    if (props.onlineOrderList.length == 1) {
      return (
        <ul className={`${styles.list} ${styles.list_one}`}>
          {props.onlineOrderList.map((item, idx) => (
            <li key={idx} id={`delicacy${idx}`} className={styles.item} onClick={() => {
              // window.df_sdk_common.location.href = item?.linkUrl;
              goLink(item, idx, item.linkUrl);
            }}
            >
              <div className={`${styles.img}`}>
                <DFImage src={item?.logo} key={item.id}></DFImage>
                <div className={styles.text}>{item?.name}</div>
              </div>
              <div className={styles.purchase}>{TLang('立即购买', 'home', false, false, null)}<img src={RightIcon} alt=""/></div>
            </li>
          ))}
        </ul>
      );
    }
  };
  return (
    <>
      {props.onlineOrderList && props.onlineOrderList.length > 0 && (
        <div id="viewMovieFood" ref={sliderRef} className={`${styles.viewMovieFood_topWrapper} viewMovieFood-wrapper`}>
          {props.onlineOrderList && props.onlineOrderList.length > 0 ? (
            <>
              <div className={styles.header}>{TLang('观影美食', 'home', false, false, null)}</div>
              <div className="scrollContainer">
                {renderList()}
              </div>
            </>
          ) : null}
        </div>
      )}
    </>
  );
};

export default ViewMoiveFood;
